export default {
    empty: {
        title: 'Select the most relevant micro-trends for the macro-trend <strong>{title}</strong>!',
        caption:
    'The “Pin Micro-Trends“ function allows you to pin the micro-trends that are most important ' +
    'for your company to individual macro-trends and thus highlight them for your colleagues.<br />' +
    'Pin matching micro-trends from the trend finder, work spaces or directly from the macro-trend detail page.',
        trendfinder: 'To Trend finder'
    }
}
